import React from 'react'
import { useNavigate } from 'react-router'

function PageNotFound() {
  const navigate = useNavigate()
  return (
    <div className='not-found'>
      <div className='not-found__body'>
      <p>404</p>
      <h1>Page not found</h1>
      <p className='not-found__body_msg'> Sorry, we couldn't find the page you're looking for.</p>
      <p className='not-found__body_home' onClick={()=>{navigate('/')}}><sl-icon name="arrow-left"></sl-icon><span> Back to home</span></p>
      </div>
      
    </div>
  )
}

export default PageNotFound
